<template>
    <div class="card mb-5 mb-xxl-8">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('user.list') }}</h3>
          </div>
          <div class="card-toolbar">
            <Button  v-if="$can(abilities.CREATE_USER)"  btn-class="btn-sm me-3" type="new" id="submit_btn" btn-text="user.create" @click="openCreateUserModal"></Button>
            <OutlineButton btn-class="me-2 btn-sm" icon-class="fa fa-file-alt" type="primary" :border="true" btn-text="exports.text" v-if="$can(abilities.EXPORT_USER) || $can(abilities.IMPORT_USER)" @click="openImportModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_user" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th> {{$t("user.initial")}}</th>
              <th> {{$t("user.lastname")}}</th>
              <th> {{$t("user.firstname")}}</th>
              <th> {{$t("user.email")}}</th>
              <th> {{$t("user.phone")}}</th>
              <th>Status</th>
              <th> {{$t("user.right")}}</th>
              <th>{{$t("actions")}}</th>
            </tr>
            </thead>
          </table>
        </div>

      </div>

    </div>
  <UserFormModal id="create-user-modal" :user="formCreateData" @afterCreate="reloadDatatable" />
  <UserFormModal id="edit-user-modal" :isEdit="true" :user="formEditData" @afterUpdate="reloadDatatable" />
  <ImportUserModal @reload="reloadDatatable"></ImportUserModal>
</template>

<script>
import {BASE_URL} from "@/services/api";
import {VueTelInput} from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
import {mapActions, mapGetters} from "vuex";
import InputTel from "@/components/InputTel.vue";
import UserFormModal from "@/components/modals/UserForm.vue"
import RightFormModal from "@/components/modals/right/Create.vue"
import {nextTick} from "vue";
import Button from "@/components/Button"
import OutlineButton from "@/components/OutlineButton.vue"
import {useSwal} from "@/composables/useSwal";
import ImportUserModal from "@/components/modals/ImportUserModal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";
import Ls from "@/services/ls";

export default {
  components: {
    InputTel,
    VueTelInput,
    UserFormModal,
    RightFormModal,
    Button,
    OutlineButton,
    ImportUserModal
  },
  data(){
    const {showSwal} = useSwal()

    return{
      formCreateData: {
        gender: '',
        lastname: '',
        firstname: '',
        initials: '',
        email: '',
        phone_code: '',
        phone: '',
        role: null,
        active: true,
        avatar : null,
        office_id: null,
        avatar_url: null,
      },
      formEditData: {
        id: null,
        gender: '',
        lastname: '',
        firstname: '',
        initials: '',
        email: '',
        phone_code: '',
        phone: '',
        role: null,
        active: false,
        avatar : null,
        row: null,
        office_id: null,
        avatar_url: null,
      },
      formDeleteData: {
        id: null,
        row: null
      },
      formCreateRightData: {
        name: '',
        description: '',
      },
      isLoading: false,
      type: 'export',
      import_file: null,
      formCreateBoxData: {
        name: '',
      },
      showSwal,
      abilities
    }
  },

  watch:{
    '$i18n.locale' : function(value){
      if(value){
        nextTick(() => this.fetchDatas() )
      }
    }
  },

  computed : {
    ...mapGetters('role', [
      'roles',
    ]),

  },

  async mounted(){
    await this.loadPosts()
    await this.loadDepartments()
    this.loadRole()
    this.fetchDatas()
  },

  methods: {
    ...mapActions('role', [
      'loadRole',
      'createRole'
    ]),
    ...mapActions('user', [
      'createUser',
      'updateUser',
      'changeUserStatus',
      'deleteUser',
      'exportUser',
      'importUser',
      'downloadUserModel'
    ]),


    ...mapActions('department', [
        'loadDepartments'
    ]),

    ...mapActions('post', [
        'loadPosts'
    ]),

    fetchDatas(){

      const AUTH_TOKEN = Ls.get('auth.token')
      const pageLimit = Ls.get('pageLength')

      this.table = $("#kt_datatable_user").DataTable({
        destroy: true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:pageLimit ||  5,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'asc']],
        ajax: {
          url: BASE_URL+"/get/users/datatables",
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
            request.setRequestHeader("Company", Ls.get('current.company'));
            },

        },
        columns: [{ data: "initials" }, { data: "lastname" },{ data: "firstname" }, { data: "email" },{ data: "phone" }, {data: 'active'},{ data: "role"}, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -8,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -7,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -6,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -5,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="emailRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -4,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="phoneRow'+ l.row +'">' + e.phone_code + " " + t + "</span>";
            },
          },

          {
            targets: -3,
            orderable:false,
            searchable:false,
            render:  (t, a, e, l) => {

              if(e.active){
                  this.formEditData.active = true
                return '<span class="form-check form-switch form-check-custom form-check-solid visible status_btn" data-id="'+ e.id +'"><label><input type="checkbox" checked id="'+ e.id +'"  class="form-check-input online h-20px w-30px" data-id="'+ e.id +'" /><span></span></label></span>';
              }else{
                  this.formEditData.active = false
                return '<span class="form-check form-switch form-check-custom form-check-solid visible status_btn" data-id="'+ e.id +'"><label> <input type="checkbox" data-id="'+ e.id +'"  id="'+ e.id +'" class="form-check-input h-20px w-30px"/><span></span></label></span>';
              }


            },

          },

          {
            targets: -2,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="emailRow'+ l.row +'">' + t + "</span>";
            },

          },
          {
            width: "15%",
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render="<div class='row'>"

              if(e.role_id && e.role !== 'Super Admin'){ 
                if(this.$can(abilities.USER_PERMISSION)){
                  render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'"  class="btn btn-sm btn-clean btn-icon user_btn_permission" title="'+ i18n.global.t('button.view_permission') +'" ><i data-row="'+ l.row +'" data-id="'+ e.id +'"  class="fas fa-user-shield fs-2" style="color: '+Theme.gray +'" ></i></a>'
                }
              }

              if(this.$can(abilities.UPDATE_USER) ){
                render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'"  data-role-id="'+ e.role_id +'"  data-email="'+ e.email +'"  data-phone_code="'+ e.phone_code +'"  data-phone="'+ e.phone +'"  data-gender="'+ e.gender +'" data-lastname="'+ e.lastname +'" data-firstname="'+ e.firstname+'" data-status="'+ e.active +'" data-avatar="'+ e.avatar_url +'" data-office="'+ e.office_id +'" data-society="'+ e.society_id +'" data-initials="'+ e.initials +'"  data-card="'+ e.card_id +'" class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'"  data-role-id="'+ e.role_id +'"  data-email="'+ e.email +'" data-phone_code="'+ e.phone_code +'"  data-phone="'+ e.phone +'"  data-gender="'+ e.gender +'" data-lastname="'+ e.lastname +'" data-firstname="'+ e.firstname +'" data-status="'+ e.active +'" data-avatar="'+ e.avatar_url +'"  data-office="'+ e.office_id +'" data-society="'+ e.society_id +'" data-initials="'+ e.initials +'"  data-card="'+ e.card_id +'" class="fas fa-edit fs-2"  style="color: '+Theme.gray +'"></i></a>'

              }
              if(this.$can(abilities.DELETE_USER) ){
                render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'"></i></a>'

              }


              return render + '</div>'
            },
          },

        ],
        language: {
          url: this.$i18n.locale == 'fr' ? "https://cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "https://cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });

      $(document).on("click", "#kt_datatable_user .edit_btn", (e) => {
        e.stopPropagation()
        this.formEditData.id = e.target.getAttribute('data-id')
        this.formEditData.gender = e.target.getAttribute('data-gender')
        this.formEditData.lastname = e.target.getAttribute('data-lastname')
        this.formEditData.firstname = e.target.getAttribute('data-firstname')
        this.formEditData.email = e.target.getAttribute('data-email')
        this.formEditData.phone = e.target.getAttribute('data-phone')
        this.formEditData.phone_code = e.target.getAttribute('data-phone_code').toString().replace('+', '')
        this.formEditData.role = e.target.getAttribute('data-role-id')
        this.formEditData.avatar_url = e.target.getAttribute('data-avatar') ?? null
        this.formEditData.avatar = e.target.getAttribute('data-avatar') ?? null
        this.formEditData.office_id = e.target.getAttribute('data-office') ?? null
        this.formEditData.society_id = e.target.getAttribute('data-society') ?? null
        this.formEditData.initials = e.target.getAttribute('data-initials') ?? null

        console.log(this.formEditData)
        $('#edit-user-modal').modal('toggle')
      });

      $(document).on("click", "#kt_datatable_user .delete_btn", (e) => {
        e.stopPropagation()
        this.formDeleteData.id = e.target.getAttribute('data-id')
        this.formDeleteData.row = e.target.getAttribute('data-row')
        this.deleteUserRow()
      });

      $(document).on("click", "#kt_datatable_user .user_btn_permission", (e) => {
        e.stopImmediatePropagation()
        this.$router.push({ name: "settings-users-permission-view", params: { id: e.target.getAttribute('data-id')} })

      });

      $(document).on("click", "#kt_datatable_user .status_btn", (e) => {
        e.stopPropagation()
        let user_id = e.target.getAttribute('data-id')
        this.activeOrInactiveUser(user_id)
      });
    },

    openImportModal() {
      $('#importUserModal').modal('toggle')
    },

    openCreateUserModal(){
      $('#create-user-modal').modal('toggle')
    },


    async activeOrInactiveUser(user_id){
      this.isLoading = true
      let response = {}
      try {
        response = await this.changeUserStatus(user_id)
        this.reloadDatatable()
        window.toastr['success'](i18n.global.t("notification.success_change_status"))
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
    },

    async deleteUserRow() {
      let response = {}
      
      this.showSwal(
          '',
          i18n.global.t('swal.user')
      ).then( async (result) => {
          if (result.value) {
            try {
              response = await this.deleteUser(this.formDeleteData.id)
              window.toastr['success'](i18n.global.t("notification.user_deleted"))
              this.table.ajax.reload()
            } catch (e) {
              if (response && response.data) {
                window.toastr['error'](response.data.error)
                return true
              }
            }
          }
      })
    },

    async createRightData(){
      this.$loading('kt_submit_create_add_right')
      let data = {
        name: this.formCreateRightData.name,
        description: this.formCreateRightData.description
      }
      let response = {}

      try{
        response = await this.createRole(data)
        window.toastr['success'](i18n.global.t("notification.right_created"))
        this.formCreateData.role = response.data.role.id
        $('#createRightModal').modal('toggle')
        this.formCreateRightData = {
          name: '',
          description: '',
        }
        this.$stopLoading('kt_submit_create_add_right')
        return true
      }catch(err){
        this.$stopLoading('kt_submit_create_add_right')
        this.isLoading = false;
      }
    },

    reloadDatatable() {
      this.table.ajax.reload()
    }
  }

}
</script>
